import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { TreeTable } from 'primereact/treetable';
import { Column } from 'primereact/column';
import '../../../../../../packages/@shared/components/src/styles/primereact-ford.css';
export const BaseTreeTable = (_a) => {
    var { columns, value, rowClassName } = _a, props = __rest(_a, ["columns", "value", "rowClassName"]);
    const numericBodyTemplate = (node, field) => {
        const val = node.data[field];
        return _jsx("span", { className: val === 0 ? 'muted-text' : '', children: val });
    };
    const combinedRowClassName = (node) => {
        const customClasses = rowClassName ? rowClassName(node) : {};
        if (Object.keys(customClasses).length > 0) {
            return customClasses;
        }
        if (!(node === null || node === void 0 ? void 0 : node.key) || typeof node.key !== 'string') {
            return { 'row-category': true };
        }
        const depth = node.key.split('-').length;
        if (depth === 1)
            return { 'row-category': true };
        if (depth === 2)
            return { 'row-model': true };
        return { 'row-submodel': true };
    };
    return (_jsx("div", { className: "base-treetable-container", children: _jsx(TreeTable, Object.assign({ value: value }, props, { className: `custom-table${props.className ? ` ${props.className}` : ''}`, rowClassName: combinedRowClassName, loading: props.loading, loadingIcon: "pi pi-spin pi-spinner", children: columns.map((col, index) => (_jsx(Column, { field: col.field, expander: col.expander, style: col.style, header: _jsx("span", { className: "column-header-wrapper", children: col.header }), body: col.isNumeric ? (node) => numericBodyTemplate(node, col.field) : col.body, className: col.className, headerClassName: col.headerClassName }, col.field || index))) })) }));
};
